import loadable from '@loadable/component';
import './TransitConnection.css';

export default loadable(() => {
  return import('./TransitConnection.jsx');
});
